import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Sectors from '../components/sections/Sectors';
import SectionDivider from '../components/common/SectionDivider';

const SectorsPage = () => {
  const theme = useTheme();

  return (
    <Box component="main" sx={{ pt: 10 }}>
      <Container maxWidth="lg" sx={{ py: 2 }}>
        <Typography variant="h2" sx={{ 
          mb: 2, 
          fontWeight: 800, 
          textAlign: 'center',
          color: 'secondary.main'
        }}>
          Industry Sectors
        </Typography>
        <Typography variant="h6" sx={{ 
          mb: 3, 
          textAlign: 'center',
          color: 'text.secondary',
          maxWidth: 800,
          mx: 'auto'
        }}>
          Serving diverse industries with specialized mechanical solutions tailored to each sector's unique requirements.
        </Typography>
      </Container>
      
      <SectionDivider variant="wave" color="secondary.main" mt={1} mb={2} />
      
      <Box sx={{ background: `linear-gradient(180deg, ${theme.palette.grey[50]}, rgba(156,39,176,0.05))` }}>
        <Sectors />
      </Box>
      
      <SectionDivider variant="line" color="secondary.main" mt={6} mb={6} />
      
      <Container maxWidth="lg" sx={{ py: 4, textAlign: 'center' }}>
        <Button 
          variant="contained" 
          size="large"
          href="tel:(516) 414-0165"
          sx={{ 
            px: 4, 
            py: 2,
            fontSize: '1.1rem',
            fontWeight: 600
          }}
        >
          Discuss Your Industry Needs
        </Button>
      </Container>
    </Box>
  );
};

export default SectorsPage;
